const seoPlans = [
    {
      name: 'Ignite',
      monthly: 550,
      keywords: 25,
      durations: {
        '1': 550,
        '3': 1500,
        '6': 2700,
        '12': 4800,
      },
      features: {
        'First Hand SEO Analysis': [
          { label: 'Pre–Optimization Website Analysis', available: true },
          { label: 'Competitor Analysis', available: true },
          { label: 'Keyword Research & Analysis', available: true },
          { label: 'Baseline Ranking Check', available: true },
          { label: 'Duplicate Content Check', available: true },
          { label: 'Google Penalty Check', available: true },
          { label: 'Back Link Analysis (if required)', available: false },
        ],
        'On-page Optimization Activities': [
          { label: 'Website Canonical Check', available: true },
          { label: 'Title Tag Optimization', available: true },
          { label: 'META Tags Optimization', available: true },
          { label: 'Heading Tags Optimization', available: false },
          { label: 'Image Alt Tags Optimization', available: true },
          { label: 'Content Optimization', available: true },
          { label: 'SEO Friendly URL Setup', available: true },
          { label: 'Site Navigation Analysis', available: true },
          { label: '404 Page Implementation', available: true },
          { label: 'Broken Links Check', available: false },
          { label: 'Website Speed Check', available: true },
          { label: 'Google Indexed Pages Check', available: true },
          { label: 'Robots.txt Creation', available: true },
          { label: 'php Sitemap Setup', available: true },
          { label: 'Google Webmasters Tool Setup', available: true },
          { label: 'Google Analytics Setup', available: true },
          { label: 'Structured Data Setup', available: false },
          { label: 'On Site Blog Section Creation', available: true },
          { label: 'On Site Blog Posting (Draft Copy) – Applicable from 3rd month1', available: true },

        ],
        'Off-page Optimization Activities': [
           { label: 'Search Engine Submission 10', available: true },
           { label: 'Article Writing 1', available: true },
           { label: 'Article Posting 1', available: true },
           { label: 'Article Bookmarking 10', available: true },
           { label: 'Classified Submissions 10', available: true },
           { label: 'Business Listing 5', available: true },
           { label: 'Blog Writing 1', available: true },
           { label: 'Blog Posting 1', available: true },
           { label: 'Blog Bookmarking 10', available: true },
           { label: 'On page Blog 1', available: true },
           { label: 'On Page Blog Bookmarking 5', available: true },
           { label: 'Image sharing 5', available: true },
           { label: 'PPT Submissions 1', available: true },
           { label: 'PPT Bookmarking 5', available: true },
           { label: 'Social Bookmarking 20', available: true },
           { label: 'PDF Sharing 1', available: true },
           { label: 'PDF bookmarking 5', available: true },
           { label: 'Profile Creation 5', available: true },
           { label: 'Quora Answering 1', available: true },
           { label: 'Info Graphic Creation 1', available: true },
           { label: 'Info Graphic Bookmarking 5', available: true },
           { label: 'Video Marketing (if Client provides)', available: true },
           { label: 'Press Release (If Client Provides News)', available: true },

        ],
        'Reports': [
          { label: 'Monthly Website Analytics Report', available: true },
          { label: 'Monthly Keywords Ranking Report', available: true },
          { label: 'Monthly Off Page Submission Report', available: true }
          
        ],
        'Customer Support': [
          { label: 'Email', available: true },
          { label: 'Phone', available: true },
          
        ],

      },
    },
    {
      name: 'Elevate',
      monthly: 900,
      keywords: 40,
      durations: {
        '1': 900,
        '3': 2600,
        '6': 4800,
        '12': 9000,
      },
      features: {
        GMB: [
          { label: 'GMB', available: true },
        ],
        'First Hand SEO Analysis': [
          { label: 'Pre–Optimization Website Analysis', available: true },
          { label: 'Competitor Analysis', available: true },
          { label: 'Keyword Research & Analysis', available: true },
          { label: 'Baseline Ranking Check', available: true },
          { label: 'Duplicate Content Check', available: true },
          { label: 'Google Penalty Check', available: true },
          { label: 'Back Link Analysis (if required)', available: false },
        ],
        'On-page Optimization Activities': [
          { label: 'Website Canonical Check', available: true },
          { label: 'Title Tag Optimization', available: true },
          { label: 'META Tags Optimization', available: true },
          { label: 'Heading Tags Optimization', available: true },
          { label: 'Image Alt Tags Optimization', available: true },
          { label: 'Content Optimization', available: true },
          { label: 'SEO Friendly URL Setup', available: true },
          { label: 'Site Navigation Analysis', available: true },
          { label: '404 Page Implementation', available: true },
          { label: 'Broken Links Check', available: true },
          { label: 'Website Speed Check', available: true },
          { label: 'Google Indexed Pages Check', available: true },
          { label: 'Robots.txt Creation', available: true },
          { label: 'Google XML Sitemap', available: true },
          { label: 'php Sitemap Setup', available: false },
          { label: 'Google Webmasters Tool Setup', available: true },
          { label: 'Google Analytics Setup', available: true },
          { label: 'Structured Data Setup', available: false },
          { label: 'On Site Blog Section Creation', available: true },
          { label: 'On Site Blog Posting (Draft Copy) – Applicable from 3rd month 1', available: true },
        ],
        'Off-page Optimization Activities': [
          { label: 'Search Engine Submission 20', available: true },
          { label: 'Article Writing 2', available: true },
          { label: 'Article Posting 2', available: true },
          { label: 'Article Bookmarking 20', available: true },
          { label: 'Classified Submissions 20', available: true },
          { label: 'Business Listing 6', available: true },
          { label: 'Blog Writing 2', available: true },
          { label: 'Blog Posting 2', available: true },
          { label: 'Blog Bookmarking 20', available: true },
          { label: 'On page Blog 2', available: true },
          { label: 'On Page Blog Bookmarking 10', available: true },
          { label: 'Image sharing 10', available: true },
          { label: 'PPT Submissions 2', available: true },
          { label: 'PPT Bookmarking 20', available: true },
          { label: 'Social Bookmarking 30', available: true },
          { label: 'PDF Sharing 2', available: true },
          { label: 'PDF Bookmarking 10', available: true },
          { label: 'Profile Creation 6', available: true },
          { label: 'Quora Answering 2', available: true },
          { label: 'Info Graphic Creation 2', available: true },
          { label: 'Info Graphic Bookmarking 10', available: true },
          { label: 'Video Marketing (if Client provides)', available: true },
          { label: 'Press Release (If Client Provides News)', available: true },
        ],
        'Reports': [
          { label: 'Monthly Website Analytics Report', available: true },
          { label: 'Monthly Keywords Ranking Report', available: true },
          { label: 'Monthly Off Page Submission Report', available: true },
        ],
        'Customer Support': [
          { label: 'Email', available: true },
          { label: 'Phone', available: true },
          { label: 'Chat', available: true },
        ],
      },
    },
    {
      name: 'Surge',
      monthly: 1250,
      keywords: 55,
      durations: {
        '1': 1250,
        '3': 3600,
        '6': 6900,
        '12': 13200,
      },
      features: {
        GMB: [
          { label: 'GBP (GMB)', available: true },
        ],
        'First Hand SEO Analysis': [
          { label: 'Pre–Optimization Website Analysis', available: true },
          { label: 'Competitor Analysis', available: true },
          { label: 'Keyword Research & Analysis', available: true },
          { label: 'Baseline Ranking Check', available: true },
          { label: 'Duplicate Content Check', available: true },
          { label: 'Google Penalty Check', available: true },
          { label: 'Back Link Analysis (if required)', available: true },
        ],
        'On-page Optimization Activities': [
          { label: 'Website Canonical Check', available: true },
          { label: 'Title Tag Optimization', available: true },
          { label: 'META Tags Optimization', available: true },
          { label: 'Heading Tags Optimization', available: true },
          { label: 'Image Alt Tags Optimization', available: true },
          { label: 'Content Optimization', available: true },
          { label: 'SEO Friendly URL Setup', available: true },
          { label: 'Site Navigation Analysis', available: true },
          { label: '404 Page Implementation', available: true },
          { label: 'Broken Links Check', available: true },
          { label: 'Website Speed Check', available: true },
          { label: 'Google Indexed Pages Check', available: true },
          { label: 'Robots.txt Creation', available: true },
          { label: 'Google XML Sitemap', available: true },
          { label: 'php Sitemap Setupx', available: true },
          { label: 'Google Webmasters Tool Setup', available: true },
          { label: 'Google Analytics Setup', available: true },
          { label: 'Structured Data Setup', available: false },
          { label: 'On Site Blog Section Creation', available: true },
          { label: 'On Site Blog Posting (Draft Copy) – Applicable from 3rd month 2', available: true },
        ],
        'Off-page Optimization Activities': [
          { label: 'Search Engine Submission 30', available: true },
          { label: 'Article Writing 3', available: true },
          { label: 'Article Posting 3', available: true },
          { label: 'Article Bookmarking 30', available: true },
          { label: 'Classified Submissions 30', available: true },
          { label: 'Business Listing 7', available: true },
          { label: 'Blog Writing 3', available: true },
          { label: 'Blog Posting 3', available: true },
          { label: 'Blog Bookmarking 30', available: true },
          { label: 'On page Blog 3', available: true },
          { label: 'On Page Blog Bookmarking 15', available: true },
          { label: 'Image sharing 15', available: true },
          { label: 'PPT Submissions 3', available: true },
          { label: 'PPT Bookmarking 30', available: true },
          { label: 'Social Bookmarking 50', available: true },
          { label: 'PDF Sharing 3', available: true },
          { label: 'PDF Bookmarking 15', available: true },
          { label: 'Profile Creation 7', available: true },
          { label: 'Quora Answering 3', available: true },
          { label: 'Info Graphic Creation 3', available: true },
          { label: 'Info Graphic Bookmarking 15', available: true },
          { label: 'Video Marketing (if Client provides)', available: true },
          { label: 'Press Release (If Client Provides News)', available: true },
        ],
        'Reports': [
         { label: 'Monthly Website Analytics Report', available: true }, 
         { label: 'Monthly Keywords Ranking Report', available: true },
         { label: 'Monthly Off Page Submission Report', available: true },
        ],
        'Customer Support': [
         { label: 'Email', available: true }, 
         { label: 'Phone', available: true },
         { label: 'Chat', available: true },
        ],

      },
    },
    {
      name: 'Conquer',
      monthly: 2000,
      keywords: 100,
      durations: {
        '1': 2000,
        '3': 5850,
        '6': 11400,
        '12': 22200,
      },
      features: {
        GMB: [
          { label: 'GBP (GMB)', available: true },
        ],
        'First Hand SEO Analysis': [
          { label: 'Pre–Optimization Website Analysis', available: true },
          { label: 'Competitor Analysis', available: true },
          { label: 'Keyword Research & Analysis', available: true },
          { label: 'Baseline Ranking Check', available: true },
          { label: 'Duplicate Content Check', available: true },
          { label: 'Google Penalty Check', available: true },
          { label: 'Back Link Analysis (if required)', available: true },
        ],
        'On-page Optimization Activities': [
          { label: 'Website Canonical Check', available: true },
          { label: 'Title Tag Optimization', available: true },
          { label: 'META Tags Optimization', available: true },
          { label: 'Heading Tags Optimization', available: true },
          { label: 'Image Alt Tags Optimization', available: true },
          { label: 'Content Optimization', available: true },
          { label: 'SEO Friendly URL Setup', available: true },
          { label: 'Site Navigation Analysis', available: true },
          { label: '404 Page Implementation', available: true },
          { label: 'Broken Links Check', available: true },
          { label: 'Website Speed Check', available: true },
          { label: 'Google Indexed Pages Check', available: true },
          { label: 'Robots.txt Creation', available: true },
          { label: 'Google XML Sitemap', available: true },
          { label: 'php Sitemap Setup', available: true },
          { label: 'Google Webmasters Tool Setup', available: true },
          { label: 'Google Analytics Setup', available: true },
          { label: 'Structured Data Setup', available: true },
          { label: 'On Site Blog Section Creation', available: true },
          { label: 'On Site Blog Posting (Draft Copy) – Applicable from 3rd month 3', available: true },
        ],
        'Off-page Optimization Activities': [
          { label: 'Search Engine Submission 40', available: true },
          { label: 'Article Writing 6', available: true },
          { label: 'Article Posting 6', available: true },
          { label: 'Article Bookmarking 40', available: true },
          { label: 'Classified Submissions 80', available: true },
          { label: 'Business Listing 10', available: true },
          { label: 'Blog Writing 6', available: true },
          { label: 'Blog Posting 6', available: true },
          { label: 'Blog Bookmarking 80', available: true },
          { label: 'On page Blog 6', available: true },
          { label: 'On Page Blog Bookmarking 80', available: true },
          { label: 'Image sharing 40', available: true },
          { label: 'PPT Submissions 8', available: true },
          { label: 'PPT Bookmarking 40', available: true },
          { label: 'Social Bookmarking 80', available: true },
          { label: 'PDF Sharing 6', available: true },
          { label: 'PDF Bookmarking 40', available: true },
          { label: 'Profile Creation 10', available: true },
          { label: 'Quora Answering 10', available: true },
          { label: 'Info Graphic Creation 6', available: true },
          { label: 'Info Graphic Bookmarking 50', available: true },
          { label: 'Video Marketing (if Client provides)', available: true },
          { label: 'Press Release (If Client Provides News)', available: true },
        ],
        'Reports': [
          { label: 'Monthly Website Analytics Report', available: true },
          { label: 'Monthly Keywords Ranking Report', available: true },
          { label: 'Monthly Off Page Submission Report', available: true },
        ],
        'Customer Support': [
          { label: 'Email', available: true },
          { label: 'Phone', available: true },
          { label: 'Chat', available: true },
        ],
      },
    },
  ];
  
  export default seoPlans;
  